export function createRoutes() {
  return [
    {
      path: 'videos',
      component: () => import(/* webpackChunkName: "VideoChrome" */ './VideoChrome.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: ':videoId',
          name: 'videodetail',
          component: () => import(/* webpackChunkName: "VideoDetail" */ './VideoDetailContainer.vue'),
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
